import { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import AppLayout from '@/components/layouts/AppLayout'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
import type { Category } from '@/types'

interface Props {
  category: Category
}

interface PageProps {
  errors?: Record<string, string[]>
}

export default function CategoriesEdit({ category }: Props) {
  const { props } = usePage<PageProps>()
  const [form, setForm] = useState({
    name: category.name,
    description: category.description || '',
    icon: category.icon || '',
    position: category.position?.toString() || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.patch(`/admin/categories/${category.slug}`, {
      category: {
        ...form,
        position: form.position ? parseInt(form.position) : null,
      },
    })
  }

  const errors = props.errors || {}

  return (
    <AppLayout title="Edit Category">
      <Paper sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>Edit Category</Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Name"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            error={!!errors.name}
            helperText={errors.name?.join(', ')}
          />
          <TextField
            label="Description"
            multiline
            rows={2}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <TextField
            label="Icon (MUI icon name)"
            placeholder="e.g. Storage, Web, Monitoring"
            value={form.icon}
            onChange={(e) => setForm({ ...form, icon: e.target.value })}
          />
          <TextField
            label="Position"
            type="number"
            value={form.position}
            onChange={(e) => setForm({ ...form, position: e.target.value })}
          />
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button onClick={() => router.visit('/admin/categories')}>Cancel</Button>
            <Button type="submit" variant="contained">Save Changes</Button>
          </Box>
        </Box>
      </Paper>
    </AppLayout>
  )
}
